import React from 'react';
export function FileIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 7.724a2 2 0 00-.464-1.28L16.6 1.72A2 2 0 0015.063 1H3v22h18V7.724zM19 21H5V3h10v5h4v13z"
  }));
}